<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" style="transform: scale(1.2)">
    <path d="M26.72,12.33H24.5l-4.29,11.5,1,2.7,1.41-3.92h5.75L29.84,27H32ZM23.18,21l2.35-6.48L27.73,21Z"
        style="fill-opacity:0.8;" />
    <path d="M13.46,18,10.05,8.26,6.43,18Zm-5-13H11.9l8.16,22H16.72l-2.28-6.59H5.55L3.12,27H0Z" />
</svg>
